import { GTP_BET_BUILDER_COMBINATION_TYPE } from '~Betslip/uiModes/shared/GTPBetBuilder/constants';
import { BET_TRACKING_TYPE } from '~spa/Components/BetHistory/BetTracking/constants.js';

export const sldReconnectPayloadFormatter = (type, data) => {
    switch (type) {
        case GTP_BET_BUILDER_COMBINATION_TYPE:
            if (!data.length) {

                return false;
            }

            return {
                type,
                action: 'register',
                combinations: data,
            };

        case BET_TRACKING_TYPE:
            if (!data.length) {

                return false;
            }

            return {
                type,
                action: 'register',
                selection_filters: data,
            };

        default:
            break;
    }

    return undefined;
};
